import { create } from 'zustand'
import { apiFetch } from '../lib/api'

export interface FxZoneData {
  current: number
  currentPercentile: number
  currentZone: string
  min: number
  max: number
  mean: number
  dataPoints: number
  boundaries: { p10: number; p30: number; p70: number; p90: number }
  history: { date: string; rate: number }[]
}

interface FxRateState {
  zoneCache: Record<number, FxZoneData>
  zoneErrors: Record<number, string>
  loadingYears: Set<number>
  loadedAt: Record<number, Date>
  loadZoneData: (years: number, force?: boolean) => Promise<void>
}

export const useFxRateStore = create<FxRateState>()((set, get) => ({
  zoneCache: {},
  zoneErrors: {},
  loadingYears: new Set(),
  loadedAt: {},

  loadZoneData: async (years, force = false) => {
    const { zoneCache, loadingYears } = get()

    if (!force && (zoneCache[years] !== undefined || loadingYears.has(years))) return

    set(s => ({
      loadingYears: new Set([...s.loadingYears, years]),
      zoneErrors: { ...s.zoneErrors, [years]: undefined as unknown as string },
    }))

    try {
      const res = await apiFetch(`/api/fx-rates/zones?years=${years}`)
      if (!res.ok) throw new Error(`Zone API: ${res.status}`)
      const data: FxZoneData = await res.json()
      if ((data as any).error) throw new Error((data as any).error)

      set(s => {
        const next = new Set(s.loadingYears)
        next.delete(years)
        return {
          zoneCache: { ...s.zoneCache, [years]: data },
          loadedAt: { ...s.loadedAt, [years]: new Date() },
          loadingYears: next,
        }
      })
    } catch (err: any) {
      set(s => {
        const next = new Set(s.loadingYears)
        next.delete(years)
        return {
          zoneErrors: { ...s.zoneErrors, [years]: err.message },
          loadingYears: next,
        }
      })
    }
  },
}))
